import { SxProps, Theme } from '@mui/material';

export const buttonSX: SxProps<Theme> = {
	borderRadius: '25px',
	paddingTop: '8px',
	paddingBottom: '8px',
	paddingLeft: '38px',
	paddingRight: '38px',
	backgroundColor: '#F1F1F1',
	color: '#774A91',
	fontSize: 'var(--font-size-lg)',
	fontWeight: 'bold',
	// mx: '6px',
	'&:hover': {
		backgroundColor: '#e1e1e1',
	},
};
